<template>
    <v-card class="scorecard-container pa-5 mt-5 mb-5">
      <v-card-title class="text-center">{{ title }}</v-card-title>
      <div class="scorecard-metric text-center text-h4">{{ formattedMetric }}</div>
      <v-card-subtitle class="text-center">{{ subtitle }}</v-card-subtitle>
    </v-card>
  </template>

  <script>
  export default {
    name: 'ScoreCard',
    props: {
      title: {
        type: String,
        required: true
      },
      subtitle: {
        type: String,
        required: true
      },
      metric: {
        type: Number,
        required: true
      }
    },
    computed: {
    formattedMetric() {
      return this.metric.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
  }
  </script>

<style lang="scss" scoped>
@import '../../assets/styles/ScoreCard.scss'
</style>
